module.exports = __webpack_public_path__ + "img/3A.b7d802b3.jpg";